import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BrandingService } from '../../core/services/branding.service';
import { DisclosuresDialogData } from '../shared-components.model';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-disclosures-qbe',
    templateUrl: './disclosures-qbe.component.html',
    styleUrls: ['./disclosures-qbe.component.scss'],
    standalone: false
})
export class DisclosuresQbeComponent {
  nameOfButton: string = 'total_premium.purchase';
  paymentMethod: string = 'form.credit_card';
  data: DisclosuresDialogData;
  brandingInfo$: Observable<any>;

  constructor(public dialogRef: MatDialogRef<DisclosuresQbeComponent>,
              private brandingService: BrandingService,
              @Inject(MAT_DIALOG_DATA) public matData: DisclosuresDialogData) {
    this.data  = matData.pageData;
    this.brandingInfo$ = brandingService.brandingInfo$;
  }
}
